"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.SnackBarType=void 0;var t;(function(e){e.BasketDeletionError="BasketDeletionError",e.LimitQuantityReached="LimitQuantityReached",e.Playlist="Playlist"})(t||(exports.SnackBarType=t={}));
//# sourceMappingURL=SnackBarType.js.map
